import { getStatusColor, CompletionBadge } from '@/components/ui/metrics'
import type { MonthPlanFact } from '@/features/history/types'

interface MetricRowProps {
  label: string
  metric: MonthPlanFact
  weeklyPlan: number
  weeklyFact: number
  formatPlan: (v: number) => string
  formatFact: (v: number) => string
}

export function MetricRow({ label, metric, weeklyPlan, weeklyFact, formatPlan, formatFact }: MetricRowProps) {
  return (
    <tr className="border-b border-border hover:bg-muted/30 transition-colors">
      <td className="p-3 pl-6 text-sm">{label}</td>
      <td className="p-3 text-right font-mono text-sm">{formatPlan(weeklyPlan)}</td>
      <td className={`p-3 text-right font-mono text-sm ${getStatusColor(metric.completion, metric.plan)}`}>
        {formatFact(weeklyFact)}
      </td>
      <td className="p-3 text-right font-mono text-sm">{formatPlan(metric.plan)}</td>
      <td className={`p-3 text-right font-mono text-sm font-semibold ${getStatusColor(metric.completion, metric.plan)}`}>
        {formatFact(metric.fact)}
      </td>
      <td className={`p-3 text-center ${getStatusColor(metric.completion, metric.plan)}`}>
        <CompletionBadge metric={metric} />
      </td>
    </tr>
  )
}
